<template>
  <div>

    <p>Aktuelle aktives Saisonjahr: {{ currentSeasonYear }}</p>

    <!-- ===================================-->
    <!-- Submit form to create a new season -->
    <!-- ===================================-->
    <div class="submit-form">
      <div v-if="!submitted">

        <div class="form-group">
          <label for="title">Zu erstellende Saison (Jahr)</label>
          <input
              type="number"
              class="form-control"
              id="title"
              required
              v-model="season.year"
              name="title"
          />
        </div>

        <button @click="initSeason" class="btn btn-success">Create</button>
        <button @click="assignDaysToSeason" class="btn btn-success">Assign Days</button>
      </div>

      <div v-else>
        <h4>You submitted successfully!</h4>
        <button class="btn btn-success" @click="newTutorial">Next</button>
      </div>
    </div>
    <!-- ======================================-->
    <!-- // Submit form to create a new season -->
    <!-- ======================================-->

    <br/>
    <p>
      <button @click="getSeasonTeams" class="btn btn-success">Import der Teams für die neue Saison</button>
    </p>
    <p>
      <button @click="getCurrentSeasonYear" class="btn btn-success">Hole aktuelle Spielzeit</button>

    </p>
    <p>
      <button @click="getSubscrptionProfits" class="btn btn-success">Trigger Profit View</button>

    </p>
    <p>
      <button @click="getCurrentSeasonMatchDaysDebug" class="btn btn-success">MatchDays Debug</button>

    </p>

    <seasons-list></seasons-list>

  </div>

</template>

<script>
import SeasonDataService from "../services/season-data.service";
import CommunityDataService from "@/services/community-data.service";
import SeasonsList from "@/components/SeasonsList.vue";

export default {
  name: "init-season",
  components: {
    SeasonsList
  },
  data() {
    return {
      season: {
        year: null
      },
      submitted: false
    };
  },
  computed: {
    currentSeasonYear() {
      return this.$store.state.sys.seasonYear;
    }
  },
  methods: {
    /*
     * Create new season
     */
    initSeason() {
      if (this.season.year == null) {
        return;
      }
      var data = {
        year: this.season.year
      };

      SeasonDataService.createSeason(data)
          .then(response => {
            console.log(response.data);
            this.submitted = true;
          })
          .catch(e => {
            console.log(e);
          });
    },
    assignDaysToSeason() {
      var data = {
        year: this.currentSeasonYear
      };

      SeasonDataService.assignDaysToSeason(data)
          .then(response => {
            console.log(response.data);
            this.submitted = true;
          })
          .catch(e => {
            console.log(e);
          });
    },
    getSeasonTeams() {
      var data = {
        year: this.currentSeasonYear
      };

      SeasonDataService.getSeasonTeams(data)
          .then(response => {
            console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });
    },
    getCurrentSeasonYear() {
      SeasonDataService.getCurrentSeasonYear()
          .then(response => {
            console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });
    },
    getCurrentSeasonMatchDaysDebug() {
      SeasonDataService.getSeasonMatchDaysDebug()
          .then(response => {
            console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });
    },
    getSubscrptionProfits() {

      CommunityDataService.getSubscription(2021)
          .then(response => {
            var data = {
              subscriptionId: response.data._id
            };
            console.log(response.data);
            CommunityDataService.getSubscriptionProfits(data)
                .then(response => {
                  console.log(response.data);
                })
                .catch(e => {
                  console.log(e);
                });
          })
          .catch(e => {
            console.log(e);
          });

    },
    newTutorial() {
      this.submitted = false;
      this.season = {};
    }
  }
};
</script>

<style>
.submit-form {
  max-width: 300px;
  margin: auto;
}
</style>